import { length, topRadius, bottomRadius, slices } from '../mixinProps'

/**
 * vc-graphics-cylinder base props mixins
 */
export default {
  mixins: [length, topRadius, bottomRadius, slices]
}
